module.exports = __webpack_public_path__ + "img/img16.d7a1e1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/03/img16.png
// module id = 223
// module chunks = 0